module.exports = __webpack_public_path__ + "img/reciever.784bb711.svg";